module.exports = __webpack_public_path__ + "img/funnel.2936adbb.svg";